export default __webpack_public_path__ + "static/media/casal_4.2a46201f.jpg";